module.exports = __webpack_public_path__ + "img/bg.c67866a1.png";